"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jwt_decode_1 = require("jwt-decode");
const errors_1 = require("../errors");
const validateIdToken = (token) => {
    if (!token) {
        throw new errors_1.RESTErrorUnauthorized('Authorization header missing');
    }
    // ak nieje JWT vratim error
    if (token.split('.').length !== 3) {
        throw new errors_1.RESTErrorUnauthorized('Authorization header mismatch');
    }
    const _a = (0, jwt_decode_1.jwtDecode)(token), { aud, sub, exp, nbf } = _a, restProps = __rest(_a, ["aud", "sub", "exp", "nbf"]);
    return Object.assign({ sportnetId: sub, app: aud }, restProps);
};
exports.default = validateIdToken;
